import { Select as OSelect } from '@osui/ui';
export const Select = OSelect;
//# sourceMappingURL=es/components/Select/Select.js.map